<template>
    <RouterView />
</template>

<script lang="ts" setup>
import { useHead } from '@unhead/vue'

import { mapLocaleToHrefLang } from '@/i18n/helpers'
import { useI18nAddon } from '@/i18n/i18n'

import { isPWARuntime } from './components_new/PWAInstall/utils'

const { currentLocale } = useI18nAddon()

useHead({
    htmlAttrs: {
        class: 'strict-px',
        lang: mapLocaleToHrefLang(currentLocale.value),
        translate: isPWARuntime() ? 'no' : 'yes',
    },
    meta: isPWARuntime()
        ? [
              {
                  name: 'viewport',
                  content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no',
              },
          ]
        : [],
})
</script>

<style>
@import '@/assets/styles/index.css';

html {
    touch-action: manipulation;
    -webkit-font-smoothing: antialiased;
}

html.strict-px {
    font-size: 1px;
}

@media (width >= 1800px) {
    html.strict-px {
        font-size: calc(100vw / 1800);
    }
}

body {
    min-height: 100%;
    background-color: var(--black);
    color: var(--white);
    font-family: var(--font-family);
    scrollbar-gutter: stable;
}
</style>
